// extracted by css-extract-rspack-plugin
export default {"shroud":"shroud__shroud___XXTIS common__zIndexShroud___kJE0s"};